<script lang="ts">
    import {Col } from "sveltestrap";
    import { Inlinetextelements } from "../../../utils/Constant/Constant";
    import Card from "../UiCommenCard.svelte";
</script>
<Col sm="12" xl="6">
    <Card cardHeaderprops="pb-0"  headerTitle={Inlinetextelements} headerContent="Styling for common inline HTML5 elements." >
      <div slot="contentbody">
        <p>You can use the mark tag to 
          <mark>highlight</mark> text.
        </p>
        <p>
          <del>This line of text is meant to be treated as deleted text.</del>
        </p>
        <p>
          <s>This line of text is meant to be treated as no longer accurate.</s>
        </p>
        <p><ins>This line of text is meant to be treated as an addition to the document.</ins></p>
        <p>
          <u>This line of text will render as underlined</u>
        </p>
        <p><small>This line of text is meant to be treated as fine print.</small></p>
        <p><strong>This line rendered as bold text.</strong></p>
        <p><em>This line rendered as italicized text.</em></p>
      </div>
    </Card>
</Col>